// Explicit endpoint-to-operation contract, never a role-to-actions policy.
export const endpointAccess: Record<string, string> = {
  login: 'session',
  logout: 'session',
  refreshToken: 'session',
  getCurrentUserProfile: 'session',
  getAllProfiles: 'ADMIN_PROFILE_LIST',
  getProfileById: 'ADMIN_PROFILE_READ',
  updateProfileById: 'ADMIN_PROFILE_UPDATE',
  inviteUser: 'ADMIN_PROFILE_SIGNUP_INITIATE',
  getProfileAttachedRoles: 'ADMIN_ATTACHED_ROLE_READ',
  getCompanyAttachedRoles: 'ADMIN_ATTACHED_ROLE_READ',
  attachIntegrationBinding: 'ADMIN_ATTACHED_ROLE_CREATE',
  updateIntegrationBinding: 'ADMIN_ATTACHED_ROLE_UPDATE',
  detachIntegrationBinding: 'ADMIN_ATTACHED_ROLE_DELETE',
  getAllCompanies: 'ADMIN_COMPANY_LIST',
  searchCompanies: 'ADMIN_COMPANY_LIST',
  getCompanyById: 'ADMIN_COMPANY_READ',
  updateCompanyById: 'ADMIN_COMPANY_UPDATE',
  deleteCompanyById: 'ADMIN_COMPANY_DELETE',
  getCompaniesStats: 'ADMIN_COMPANY_STATS_READ',
  getCompanyStats: 'ADMIN_COMPANY_STATS_READ',
  getCompanyStatsTimeseries: 'ADMIN_COMPANY_STATS_READ',
  getCompanyBillingAccount: 'ADMIN_BILLING_ACCOUNT_READ',
  createBillingAccount: 'ADMIN_BILLING_ACCOUNT_CREATE',
  updateBillingAccountById: 'ADMIN_BILLING_ACCOUNT_UPDATE',
  deleteBillingAccountById: 'ADMIN_BILLING_ACCOUNT_DELETE',
  getRoles: 'ADMIN_ROLE_LIST',
  getRoleById: 'ADMIN_ROLE_READ',
  createIntegrationDefinition: 'ADMIN_ROLE_CREATE',
  updateIntegrationDefinition: 'ADMIN_ROLE_UPDATE',
  deleteIntegrationDefinition: 'ADMIN_ROLE_DELETE',
  getAllTags: 'ADMIN_TAG_LIST',
  getTagById: 'ADMIN_TAG_READ',
  createTag: 'ADMIN_TAG_CREATE',
  updateTagById: 'ADMIN_TAG_UPDATE',
  deleteTagById: 'ADMIN_TAG_DELETE',
  getAllMlTags: 'legacyFilerAdminOnly',
  getMlTagById: 'legacyFilerAdminOnly',
  createMlTag: 'legacyFilerAdminOnly',
  updateMlTagById: 'legacyFilerAdminOnly',
  deleteMlTagById: 'legacyFilerAdminOnly',
  getTranslations: 'legacyFilerAdminOnly',
  getTranslationById: 'legacyFilerAdminOnly',
  createTranslation: 'legacyFilerAdminOnly',
  updateTranslationById: 'legacyFilerAdminOnly',
  deleteTranslationById: 'legacyFilerAdminOnly',
  getAllDeliveries: 'ADMIN_DELIVERY_LIST',
  getDeliveryById: 'ADMIN_DELIVERY_READ',
  getAllUsages: 'ADMIN_USAGE_LIST',
  getUsageById: 'ADMIN_USAGE_READ',
  updateUsageById: 'ADMIN_USAGE_UPDATE',
  getTemplates: 'ADMIN_DELIVERY_TEMPLATE_LIST',
  getTemplateById: 'ADMIN_DELIVERY_TEMPLATE_READ',
  createTemplate: 'ADMIN_DELIVERY_TEMPLATE_CREATE',
  updateTemplateById: 'ADMIN_DELIVERY_TEMPLATE_UPDATE',
  deleteTemplateById: 'ADMIN_DELIVERY_TEMPLATE_DELETE',
  getSections: 'ADMIN_DELIVERY_TEMPLATE_SECTIONS_READ',
  getImages: 'ADMIN_DELIVERY_TEMPLATE_IMAGES_READ',
  getLabels: 'ADMIN_TEXT_LABEL_LIST',
  updateTextLabel: 'ADMIN_TEXT_LABEL_UPDATE',
  getPlans: 'ADMIN_TARIFF_PLAN_LIST',
  getPlanById: 'ADMIN_TARIFF_PLAN_READ',
  createPlan: 'ADMIN_TARIFF_PLAN_CREATE',
  updatePlanById: 'ADMIN_TARIFF_PLAN_UPDATE',
  deletePlanById: 'ADMIN_TARIFF_PLAN_DELETE',
  makePlanDefault: 'ADMIN_TARIFF_PLAN_MAKE_DEFAULT',
  assignBillingAccount: 'ADMIN_TARIFF_PLAN_ASSIGN',
  getNotifications: 'ADMIN_EMAIL_NOTIFICATION_LIST',
  createNotification: 'ADMIN_EMAIL_NOTIFICATION_CREATE',
  updateNotificationById: 'ADMIN_EMAIL_NOTIFICATION_UPDATE',
  deleteNotificationById: 'ADMIN_EMAIL_NOTIFICATION_DELETE',
  getRequests: 'ADMIN_SIGNUP_REQUEST_LIST',
  getSignupRequestById: 'ADMIN_SIGNUP_REQUEST_READ',
  updateSignupRequest: 'ADMIN_SIGNUP_REQUEST_UPDATE',
  deleteSignupRequest: 'ADMIN_SIGNUP_REQUEST_DELETE',
  approveSignupRequest: 'ADMIN_SIGNUP_REQUEST_APPROVE',
  rejectSignupRequest: 'ADMIN_SIGNUP_REQUEST_REJECT',
  getDeletionRequests: 'ADMIN_DELETION_REQUEST_LIST',
  processDeletionRequest: 'ADMIN_DELETION_REQUEST_PROCESS',
  listDashboardShareTokens: 'ADMIN_DASHBOARD_SHARE_LIST',
  createDashboardShareToken: 'ADMIN_DASHBOARD_SHARE_CREATE',
  revokeDashboardShareToken: 'ADMIN_DASHBOARD_SHARE_REVOKE',
  getPlatformRoleCatalog: 'ADMIN_PLATFORM_ROLE_CATALOG_READ',
  getPlatformRoleRoster: 'ADMIN_PLATFORM_ROLE_ASSIGNMENTS_READ',
  getPlatformRoleAssignments: 'ADMIN_PLATFORM_ROLE_ASSIGNMENTS_READ',
  grantPlatformRole: 'ADMIN_PLATFORM_ROLE_GRANT',
  revokePlatformRole: 'ADMIN_PLATFORM_ROLE_REVOKE',
  getPlatformRoleEvents: 'ADMIN_PLATFORM_ROLE_HISTORY_READ',
  getAuthorizationDecisions: 'ADMIN_AUTHORIZATION_DECISION_READ',
  getAuthorizationPartitions: 'ADMIN_AUTHORIZATION_DECISION_PARTITIONS_READ',
};
